import { Outlet } from "react-router-dom";

import { UrlHistoryProvider } from "../UrlHistoryContext";

export function HistoryLayout() {
  return (
    <UrlHistoryProvider>
      <Outlet />
    </UrlHistoryProvider>
  );
}
